import { Component, Input, HostListener, OnInit } from '@angular/core';
import { properties } from 'src/environments/properties';

declare let $: any;

@Component({
  selector: 'app-customer-details-header-v2',
  templateUrl: './customer-details-header-v2.component.html',
  styleUrls: ['./customer-details-header-v2.component.scss']
})
export class CustomerDetailsHeaderV2Component implements OnInit {

  @Input() displaySubTypeLink: boolean;
  @Input() userSubscriptionDetails: any;
  properties = properties;
  private resizeTimeout: any;
  KEYCODE_TAB: number = 9;
  SMALL_SCREEN_WIDTH = 768;
  DEFAULT_TOOLTIP_OFFSET = -65;
  SMALL_TOOLTIP_OFFSET = 10;

  subTypeLink: [string];
  userCustomerDetails: any = {
    subscriptionType: '',
    lifeTimeSavings: '',
    timeSavings: '',
  }
  
  freshpassBenefitsDescription = properties.freshpassData.fpBenefitsDescription;
  freshpassTitle = properties.freshpassData.freshpassTitle;

  LIFETIMESAVINGS_TEXT = properties.freshpassData.lifeTimeSavingsText;
  HOURSSAVED_TEXT = properties.freshpassData.hoursSavedText;

  @HostListener('window:resize', ['$event'])
  onResize() {
    clearTimeout(this.resizeTimeout);
    this.resizeTimeout = setTimeout(() => {
      this._initFreshpassTooltips(true);
    }, 300);
  }

  @HostListener("keydown", ["$event"])
  onKeyDown(e: KeyboardEvent): any {
      if ($('.savings-tooltip').length) {
      
          if (e.key === 'Tab' || e.code === 'Tab') {
              e.preventDefault();
          }
      }
  }

  ngOnInit(): void {
    this.setCustomerHeaderDetails();
    this.setSubTypeLink();
    this._initFreshpassTooltips();
  }

  setCustomerHeaderDetails() {
    let subscriptionStatus =
      this.userSubscriptionDetails?.status === properties.manage.SUSPENDED
        ? "Suspended"
        : this.userSubscriptionDetails?.status?.toUpperCase() === properties.manage.TRIAL
        ? "Free Trial"
        : this.userSubscriptionDetails?.subscriptionType.replace("Plan", "Subscription");
    this.userCustomerDetails = {
      subscriptionType: subscriptionStatus,
      lifeSavings: this.userSubscriptionDetails?.lifeSavings,
      timeSavings: this.userSubscriptionDetails?.timeSavings,
      isPrimaryFreshPassUser: this.userSubscriptionDetails?.isPrimaryFreshPassUser,
    };
  }

  setSubTypeLink() {
    this.subTypeLink = ['/freshpass/manage'];
  }

  _initFreshpassTooltips = (resizeEvent = false) => {
      let tooltipOffset = this.updateTooltipOffsets();
      const tooltip = '.freshPassTooltip';
      let tooltipPopupTriggeringElement = null;
      if ($(tooltip).length) {
          $(tooltip).tooltip('dispose');
          // Initialise icon tooltip
          $(tooltip).each(function (e) {
              $(this).tooltip({
                  trigger: 'hover click',
                  html: true,
                  template: '<div class="tooltip savings-tooltip freshpass-tiles__tooltipIcon" aria-live="polite" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>',
                  container: $(this).closest('.tooltip-container'),
                  placement: 'bottom',
                  offset: tooltipOffset
              });

              $(this).on('shown.bs.tooltip', function () {
                const arrow = $(this).data('bs.tooltip').tip.querySelector('.arrow');
                const currentLeft = parseInt(arrow.style.left, 10);
                arrow.style.left = `${currentLeft + 4}px`;
              });

              $(this).on('click', function () {
                  if (tooltipPopupTriggeringElement === null) tooltipPopupTriggeringElement = $(this);
                  $('.tooltip-close-container').attr("tabindex", '0').focus();
                  $('.tooltip-inner-info-content').attr("tabindex", '-1')
                  $('.tooltip-inner').attr('aria-hidden', 'false');
                  $(this).attr('aria-expanded', 'true');
              });
              $(this).on('keydown', function (e) {
                  if ((e.which == 13 || e.which == 32) && $(this).is(':focus')) {
                      e.preventDefault();
                      $(this).tooltip('show');
                      if (tooltipPopupTriggeringElement === null) tooltipPopupTriggeringElement = $(this);
                      $('.tooltip-close-container').attr('tabindex', '0').focus();
                      $('.tooltip-inner-info-content').attr("tabindex", '-1')
                      $('.tooltip-inner').attr('aria-hidden', 'false');
                      $(this).attr('aria-expanded', 'true');
                  }
              });
          })

          $(document).on('click', '.tooltip-close-container', function () {
              const idOfElement = $(this).parent().parent().parent().attr('id');
              $('*[aria-describedby="' + idOfElement + '"]').tooltip('hide');
              if(tooltipPopupTriggeringElement)
              {
                tooltipPopupTriggeringElement.focus();
              }
              tooltipPopupTriggeringElement = null;
              $('.freshPassTooltip').attr('aria-expanded', 'false').focus();
          });

          // On click event for dismissing tooltip on click outside
          $(document).on('click', function (e) {
              $('[data-toggle=tooltip]').each(function () {
                  // hide any open tooltips anywhere else in the body is clicked
                  if (!$(this).is(e.target) && $(this).has(e.target).length === 0 &&
                      $('.tooltip').has(e.target).length === 0 && !$('.freshPassTooltip').is(e.target)) {
                      $(this).tooltip('hide').attr('aria-expanded', 'false');
                  }
                  // On click event on icon
                  if ($(this).is(e.target)) {
                      $(this).attr('aria-expanded', (i, attr) => {
                          if (attr === 'true') {
                              $('.tooltip-close-container').attr("tabindex", "-1");
                              $('.freshPassTooltip').focus();
                              return 'false'
                          } else {
                              return 'true'
                          }
                      });
                  }
              });
          });

          $(document).on('keydown', '.tooltip-close-container', function (e) {
              if ((e.which == 13 || e.which == 32) && $(this).is(':focus')) {
                  e.preventDefault();
                  $('.freshPassTooltip').tooltip('hide').attr('aria-expanded', 'false').focus();
              }
          });
      }
  }

  updateTooltipOffsets = () => {
    const screenWidth = window.innerWidth;
    let offset;

    if (screenWidth < this.SMALL_SCREEN_WIDTH) {
      offset = this.SMALL_TOOLTIP_OFFSET;
    } else {
      offset = this.DEFAULT_TOOLTIP_OFFSET;
    }
    return offset
  }
}
